// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2DnBy","footer":"ModalError_footer__2mmJu"};